import { render, staticRenderFns } from "./stuActivtyUpload.vue?vue&type=template&id=6d3bb604"
import script from "./stuActivtyUpload.vue?vue&type=script&lang=js"
export * from "./stuActivtyUpload.vue?vue&type=script&lang=js"
import style0 from "./stuActivtyUpload.vue?vue&type=style&index=0&id=6d3bb604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports